module.exports = __webpack_public_path__ + "static/media/man-working-in-office.232d9f24.svg";